import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Aptitude } from '../models/aptitude.model';
import { avecMéthodesAptitudes } from './aptitude.methods';
import { avecSélecteursAptitudes } from './aptitude.selectors';
import { AptitudeState, initialState } from './aptitude.state';
import { withSelectedEntity } from '../../../../shared/store/selected-entity.feature';

export const AptitudeStore = signalStore(
  { providedIn: 'root' },
  withState<AptitudeState>(initialState),
  withEntities<Aptitude>(),
  withSelectedEntity(),
  avecMéthodesAptitudes(),
  avecSélecteursAptitudes(),
);
